var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_222",
    "data-name": "Group 222",
    xmlns: "http://www.w3.org/2000/svg",
    width: 747.28,
    height: 462.177,
    viewBox: "0 0 747.28 462.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n      --primary-color: #9138b0;\n      --secondary-color: #D9B0EA;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    width: 747.28,
    height: 462.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    width: 38.417,
    height: 32.759,
    transform: "translate(278.988 137.902)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    width: 38.416,
    height: 32.759,
    transform: "translate(266.381 224.24)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    width: 38.416,
    height: 32.759,
    transform: "translate(433.393 137.423)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    width: 38.417,
    height: 32.759,
    transform: "translate(442.968 221.92)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    width: 742.281,
    height: 457.177,
    rx: 36.218,
    transform: "translate(2.5 2.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    width: 684.796,
    height: 390.001,
    rx: 27.595,
    transform: "translate(31.242 36.088)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    d: "M437.678,216.308V173.127H394.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    d: "M309.6,216.308V173.127h43.181",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    d: "M309.6,258.021V301.2h43.181",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    d: "M437.678,258.021V301.2H394.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 352.21)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    d: "M598.657,364.474c0,13.092-97.183,23.7-217.065,23.7s-217.065-10.612-217.065-23.7,97.183-23.7,217.065-23.7,217.065,10.612,217.065,23.7",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 340.77)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    d: "M406.281,238.3A35.183,35.183,0,1,1,371.1,203.117",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    width: 29.281,
    height: 29.281,
    transform: "translate(382.085 199.667)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    width: 29.281,
    height: 29.281,
    transform: "translate(364.33 214.307)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    d: "M394.029,364.349a13.406,13.406,0,1,1-13.406-13.406",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    width: 11.157,
    height: 11.157,
    transform: "translate(384.809 349.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    width: 11.157,
    height: 11.157,
    transform: "translate(378.044 355.207)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    d: "M299.371,169.661S297.609,153.8,279.988,153.8",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    d: "M312.881,161.732a27.011,27.011,0,0,1,3.524-19.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    d: "M296.13,146.68s-6.168-6.973-15.018-6.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    d: "M303.907,156.6s-1.073-12.872,3.486-17.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    d: "M286.764,256S285,240.14,267.381,240.14",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    d: "M300.273,248.07a27.011,27.011,0,0,1,3.524-19.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    d: "M283.522,233.017s-6.168-6.973-15.018-6.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    d: "M291.3,242.94s-1.073-12.872,3.486-17.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    d: "M451.426,169.182s1.762-15.859,19.383-15.859",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    d: "M437.917,161.252a27.011,27.011,0,0,0-3.524-19.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    d: "M454.668,146.2s6.168-6.973,15.018-6.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    d: "M446.891,156.122s1.073-12.872-3.486-17.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    d: "M461,253.679s1.762-15.859,19.383-15.859",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    d: "M447.492,245.749a27.011,27.011,0,0,0-3.524-19.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    d: "M464.243,230.7s6.168-6.973,15.018-6.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    d: "M456.466,240.62s1.073-12.872-3.486-17.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction3);
export default __webpack_public_path__ + "static/media/instruction3.c52b5868ac155ede370cc9371e19e1a8.svg";
export { ForwardRef as ReactComponent };